module.exports = __webpack_public_path__ + "static/img/xie.a46e45c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xie.jpg
// module id = RQCX
// module chunks = 1